<script>
    import { onMount } from "svelte";
    import { SendRequest, PostRequestWithBody } from "./APIService";
    import { showModal } from "./Modal";

    const MARKET = [
        { value: 0, label: "Cafe Bazaar" },
        { value: 1, label: "Google Play" },
        { value: 2, label: "App Store" },
        { value: 3, label: "Test Store" },
        { value: 4, label: "Myket" },
        { value: 5, label: "SibApp" },
        { value: 6, label: "IranApps" },
        { value: 7, label: "ZarrinPal Google" },
        { value: 8, label: "ZarrinPal Apple" },
        { value: 9, label: "BazaarPay" },
    ];

    const CATEGORY = [
        { value: 0, label: "Payment" },
        { value: 1, label: "Recovery Account" },
        { value: 2, label: "Technical" },
        { value: 3, label: "Report User" },
        { value: 4, label: "Suggestion" },
        { value: 5, label: "Others" },
    ];

    let marketType = 0;
    let category = 0;

    let answers = [];

    onMount(load);

    function load() {
        SendRequest(
            "CRMReadyAnswer",
            "GET",
            `marketType=${marketType}&category=${category}`,
            (data) => {
                answers = data?.answers ?? [];
            },
            () => {
                answers = [];
            },
        );
    }

    function addAnswer() {
        answers = [...answers, ""];
    }

    function removeAnswer(index) {
        answers = answers.filter((_, i) => i !== index);
    }

    function save() {
        const model = {
            marketType: Number(marketType),
            category: Number(category),
            answers: answers.map((x) => x.trim()).filter((x) => x.length > 0),
        };

        console.log({
            marketType: Number(marketType),
            category: Number(category),
            answers,
        });

        PostRequestWithBody(
            "UpdateCRMReadyAnswers",
            "POST",
            model,
            () => {
                showModal("Done", "Saved successfully", "OK");
            },
            (err) => {
                showModal("Error", err, "OK");
            },
        );
    }
</script>

<div class="card">
    <div class="card-header">
        <h5>CRM Ready Answers</h5>
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="form-label">Market</label>

                <select
                    class="form-select"
                    bind:value={marketType}
                    on:change={() => {
                        marketType = Number(marketType);
                        load();
                    }}
                >
                    {#each MARKET as item}
                        <option value={item.value}>
                            {item.label}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="col-md-6">
                <label class="form-label">Category</label>

                <select
                    class="form-select"
                    bind:value={category}
                    on:change={() => {
                        category = Number(category);
                        load();
                    }}
                >
                    {#each CATEGORY as item}
                        <option value={item.value}>
                            {item.label}
                        </option>
                    {/each}
                </select>
            </div>
        </div>

        <hr />

        {#if answers.length === 0}
            <div class="text-muted mb-3">No ready answers.</div>
        {/if}

        {#each answers as answer, index}
            <div class="d-flex gap-2 mb-3">
                <textarea
                    class="form-control"
                    rows="5"
                    bind:value={answers[index]}
                    placeholder="Ready answer..."
                ></textarea>

                <button
                    type="button"
                    class="btn btn-outline-danger align-self-start"
                    on:click={() => removeAnswer(index)}
                >
                    Delete
                </button>
            </div>
        {/each}

        <button
            type="button"
            class="btn btn-outline-primary mt-2"
            on:click={addAnswer}
        >
            + Add Answer
        </button>

        <hr />

        <button type="button" class="btn btn-success" on:click={save}>
            Save
        </button>
    </div>
</div>
